// import Vue from 'vue'
import { fb } from '../plugins/firebase'
import { momento } from '../plugins/moment'
// import { limpiar } from '../mixins/limpiar'

export default {
  namespaced: true,
  state: {
    estados: [
      'INGRESADA',
      'INGRESADA WEB',
      'PAGADA',
      'ENTREGADA',
      'ENVIADA',
      'ENVIO PENDIENTE',
      'CANCELADA'
    ],
    origenes: ['Local', 'Web', 'Teléfono'],
    origen: 'Local',
    venta: [],
    allVentas: [],
    filtros: {
      tipo: 'dia',
      dia: momento().format('YYYY-MM-DD'),
      mes: 'Mes Actual',
      status: 'TODOS'
    },
    datos: {
      venta: []
    },
    ventaDatos: {
      status: 'INGRESADA',
      fecha: momento().format('YYYY-MM-DD'),
      timestamp: momento().format(),
      anio: momento().format('YYYY'),
      mes: momento().format('MM'),
      dia: momento().format('DD'),
      sucursal: 'Casa Matriz',
      origen: 'Local',
      cotizacion: '',
      fechaCotizacion: '',
      usuario: '',
      entregado: false,
      enviado: false
    },
    pagoDatos: {
      documento: '',
      numeroDcto: 0,
      metodo: '',
      redondeo: false,
      redondeado: 0,
      cantidadTotal: 0,
      descuento: 0,
      total: 0,
      calculado: 0
    },
    ventasCliente: []
  },
  mutations: {
    addVenta (state, p) {
      let existe = state.venta.find(sel => sel.id === p.id)
      if (!existe)
        state.venta.push(p)
    },
    setVentaDatos (state, p) {
      state.ventaDatos = p
    },
    setPagoDatos (state, p) {
      state.pagoDatos = p
    },
    setOrigen (state, p) {
      state.origen = p
    },
    setVenta (state, p) {
      state.venta = p
    },
    setFiltros (state, p) {
      state.filtros = p
    },
    setAllVentas (state, p) {
      state.allVentas = p
    },
    unshiftAllVentas (state, p) {
      state.allVentas.unshift(p)
    },
    cambiarEstado (state, p) {
      let existe = state.allVentas.find(sel => sel.id === p.id)
      if (existe)
        existe.status = p.status
    },
    eliminarVenta (state, p) {
      let existe = state.venta.findIndex(sel => sel.id === p)
      if (existe !== -1)
        state.allVentas.splice(existe, 1)
    },
    ventasCliente (state, p) {
      state.ventasCliente = p
    },
  },
  actions: {
    realizarVenta (ctx, p) {
      return new Promise ((resolve, reject) => {
        let dat = {
          ...p,
          ...ctx.state.ventaDatos,
          ...ctx.state.pagoDatos
        }
        fb.collection('ventas').add(dat)
        .then(() => {
          if (dat.entregado || dat.enviado)
            ctx.dispatch('resolverReduccion', p.venta)
          let anadir = false
          if (ctx.state.filtros.tipo === 'dia' && ctx.state.filtros.dia === dat.fecha)  
            if (ctx.state.filtros.status === 'TODOS')
              anadir = true
            else if (ctx.state.filtros.status === dat.status)
              anadir = true
          if (ctx.state.filtros.tipo === 'mes')
            if (ctx.state.filtros.tipo === 'Mes Actual')
              if (dat.mes === momento().format('MM') && dat.anio === momento().format('YYYY'))
                if (ctx.state.filtros.status === 'TODOS')
                  anadir = true
                else if (ctx.state.filtros.status === dat.status)
                  anadir = true
            if (ctx.state.filtros.tipo === 'Mes Anterior')
              if (dat.mes === momento().subtract(1, 'month').format('MM') && dat.anio === momento().subtract(1, 'month').format('YYYY'))
                if (ctx.state.filtros.status === 'TODOS')
                  anadir = true
                else if (ctx.state.filtros.status === dat.status)
                  anadir = true
          if(anadir)
            ctx.commit('unshiftAllVentas', dat)
            if (dat.cotizacion !== '')
              if (dat.enviado)
                fb.collection('cotizaciones').doc(dat.cotizacion).update({status: 'COMPLETADA'})
              else
                fb.collection('cotizaciones').doc(dat.cotizacion).update({status: 'ENVIO PENDIENTE'})
          ctx.commit('setVenta', [])
          if (dat.usuario !== '') {
            gustos(dat).then(() => resolve())
          } else {
            return resolve()
          }
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    getAllVentas (ctx) {
      return new Promise ((resolve, reject) => {
        let filtros = ctx.state.filtros
        let all = []
        let split = filtros.dia.split('-')
        let p = null
        if (filtros.tipo === 'dia') {
          if (filtros.status === 'TODOS')
            p = fb.collection('ventas').where('anio', '==', split[0]).where('mes', '==', split[1]).where('dia', '==', split[2]).get()
          else 
            p = fb.collection('ventas').where('anio', '==', split[0]).where('mes', '==', split[1]).where('dia', '==', split[2]).where('status', '==', filtros.status).get()
        } else if (filtros.tipo === 'mes' && filtros.mes !== 'Esta Semana') {
          let mes = null
          let year = null
          if (filtros.mes === 'Mes Actual') {
            mes = momento().format('MM')
            year = momento().format('YYYY')
          } else if (filtros.mes === 'Mes Anterior'){
            mes = momento().subtract(1, 'month').format('MM')
            year = momento().subtract(1, 'month').format('YYYY')
          }
          if (filtros.status === 'TODOS')
            p = fb.collection('ventas').where('anio', '==', year).where('mes', '==', mes).get()
          else
            p = fb.collection('ventas').where('anio', '==', year).where('mes', '==', mes).where('status', '==', filtros.status).get()
        }
        p.then(results => {
          results.forEach(docs => {
            let item = docs.data()
            item.id = docs.id
            all.push(item)
          })
          let final = all.sort((a, b) => momento(b.timestamp).format('x') - momento(a.timestamp).format('x'))
          ctx.commit('setAllVentas', final)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    cambiarEstado (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('ventas').doc(p.id).update({status: p.status})
        .then(() => {
          ctx.commit('cambiarEstado', p)
          if (p.cotizacion == '' && (p.status === 'ENVIADA' || p.status === 'PAGADA'))
            fb.collection('cotizaciones').doc(p.cotizacion).update({status: 'COMPLETADA'})
          if (p.status === 'ENTREGADA' || p.status === 'ENVIADA') {
            ctx.dispatch('resolverReduccion', p.venta)
          }
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    eliminarVenta (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('ventas').doc(p).delete()
        .then(() => {
          ctx.commit('eliminarVenta', p)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    reducirStock(ctx, p) {
      return new Promise ((resolve, reject) => {
        let hay = 0
        let nuevaExistencia = 0
        let prom = null
        fb.collection('libros').doc(p.id).get()
        .then(doc => {
          if (p.tipo === 'nuevo')
            hay = doc.data().nuevoQ
          else if (p.tipo === 'usado')
            hay = doc.data().usadoQ
          else 
            return reject()
          nuevaExistencia = hay - p.cantidad
          if (nuevaExistencia < 0)
            nuevaExistencia = 0
          if (p.tipo === 'nuevo')
            prom = fb.collection('libros').doc(p.id).update({nuevoQ: nuevaExistencia}) 
          else if (p.tipo === 'usado')
            prom = fb.collection('libros').doc(p.id).update({usadoQ: nuevaExistencia}) 
          return prom
        })
        .then(() => {
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    resolverReduccion (ctx, p) {
      return new Promise((resolve, reject) => {
        let promesas = []
        p.forEach(item => {
          let pr = ctx.dispatch('reducirStock', {id: item.id, cantidad: item.cantidad, tipo: item.tipo})
          promesas.push(pr)
        })
        Promise.all(promesas)
        .then(() => {
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    ventasCliente (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('ventas').where('usuario', '==', p.usuario).get()
        .then(results => {
          let all = []
          results.forEach(doc => {
            let pedido = doc.data()
            pedido.id = doc.id
            all.push(pedido)
          })
          ctx.commit('ventasCliente', all)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    }
  },
  getters: {
    getVenta: (state) => state.venta,
    getOrigen: (state) => state.origen,
    estados: (state) => state.estados,
    origenes: (state) => state.origenes,
    filtros: (state) => state.filtros,
    getAllVentas: (state) => state.allVentas,
    ventaDatos: (state) => state.ventaDatos,
    pagoDatos: (state) => state.pagoDatos,
    ventasCliente: (state) => state.ventasCliente
  }
}

function gustos (p) {
  return new Promise ((resolve, reject) => {
    let gustos = new Set()
    fb.collection('gustos').doc(p.usuario).get()
    .then(doc => {
      if (doc.exists) {
        doc.data().gustos.forEach(gusto => {
          gustos.add(gusto)
        })
      }
      p.venta.forEach(venta => {
        if (venta.coleccion)
          gustos.add(venta.coleccion)
      })
      return fb.collection('gustos').doc(p.usuario).set({gustos: Array.from(gustos)})
    })
    .then(() => {
      resolve()
    })
    .catch(e => {
      console.error(e)
      reject()
    })
  })
}